import { memo, useEffect, useState } from 'react';
import {
  DocumentListResponse,
  MaterialRequisitionDocumentResponse,
} from '@Types/api/form';
import { getDocument, getFileTypeExt } from '@Features/utils/document';
import { useFormListMutation } from '@Store/api/dmsApiSlice';
import MaterialDocumentItem from '../../../View/components/DocumentsTab/MaterialDocumentItem';

import styles from '../details.module.css';
import { getDocumentFolder } from '../../../utils/document';

interface DocumentDetailsProps {
  requisitionId: number;
  list: MaterialRequisitionDocumentResponse[];
}

const DocumentDetails: React.FC<DocumentDetailsProps> = ({
  list,
  requisitionId,
}) => {
  const [getFormList] = useFormListMutation();
  const [documentsInFolder, setDocumentsInFolder] =
    useState<DocumentListResponse[]>();

  const handleDownload = (url: string | undefined, filePath: string): void => {
    if (url) {
      const a = document.createElement('a');
      a.href = url;
      a.download = filePath;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  };

  useEffect(() => {
    if (requisitionId) {
      const documentFolderPath = getDocumentFolder(requisitionId);

      getFormList(documentFolderPath)
        .unwrap()
        .then((response) => {
          setDocumentsInFolder(response);
        });
    }
  }, [requisitionId]);

  return (
    <div className={styles.details}>
      {list.map((document) => {
        const matchedDocument =
          documentsInFolder &&
          getDocument(documentsInFolder, document.filePath);

        return (
          <MaterialDocumentItem
            description={document.docDesc}
            name={document.docName}
            status={Boolean(document.deleteFlag)}
            isConfidential={Boolean(document.isConfidential)}
            type={getFileTypeExt(document.filePath)}
            key={`${document.docName}-${document.filePath}`}
            filePath={document.filePath}
            documentId={matchedDocument?.documentId}
            onDownload={handleDownload}
          />
        );
      })}
    </div>
  );
};

export default memo(DocumentDetails);
